import React from 'react';
import styles from './Pagination.module.css';
import { TablePagination } from '@mui/material';

function Pagination({page, tableData, dataPerPage = 25, handleChangePage, handleChangeRowsPerPage, totalTableData}) {

    const handleChangePages = (event, newPage) => {
        handleChangePage(event, newPage);
    };

    const handleChangeRowsPerPages = (event) => {
        handleChangeRowsPerPage(parseInt(event.target.value, 10));
        handleChangePage(event, 0);
    };

    return (
        <TablePagination
            rowsPerPageOptions={[]}
            component="div"
            count={totalTableData ? totalTableData : tableData.length}
            rowsPerPage={dataPerPage}
            page={page}
            onPageChange={handleChangePages}
            onRowsPerPageChange={handleChangeRowsPerPages}
            sx={{
                padding: 0,
                "& .MuiTablePagination-toolbar": {
                    minHeight: "20px",
                    fontSize: "12px",
                },
                "& .MuiTablePagination-select": {
                    fontSize: "12px"
                },
                "& .MuiTablePagination-selectLabel": {
                    fontSize: "12px"
                },
                "& .MuiTablePagination-displayedRows": {
                    fontSize: "12px"
                },
                "& .MuiTablePagination-actions": {
                    marginLeft: "10px"
                },
                "& .MuiIconButton-root": {
                    fontSize: "14px"
                },
                "& .MuiSvgIcon-root": {
                    height: "14px",
                    width: "14px",
                    fontSize: "14px"
                },
            }}
        />
    )
}

export default Pagination;